// src/services/userService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getUsers = async () => {
  const event_id = parseInt(localStorage?.getItem('event_id'));
  return await axios.get(`${API_URL}/users/usersbyevent/${event_id}`);
};

const getUser = async (id) => {
  const event_id = parseInt(localStorage?.getItem('event_id'));
  return await axios.get(`${API_URL}/events/${event_id}/users/${id}`);
};

const createUser = async (userData) => {
   const event_id = parseInt(localStorage?.getItem('event_id'));
  return await axios.post(`${API_URL}/events/${event_id}/users/assign`, userData);
};

const updateUser = async (id, userData) => {
   const event_id = parseInt(localStorage?.getItem('event_id'));
  return await axios.put(`${API_URL}/events/${event_id}/users/${id}`, userData);
};

const deleteUser = async (id) => {
  const event_id = parseInt(localStorage?.getItem('event_id'));
  return await axios.delete(`${API_URL}/events/${event_id}/users/${id}`);
};

export default {
  getUsers,
  getUser,
  createUser,
  updateUser,
  deleteUser,
};
